// extracted by mini-css-extract-plugin
export default {"notAuthorized":"NotAuthorizedContent_notAuthorized__MHnxx"};